module.exports = __webpack_public_path__ + "static/img/a1.7454635.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/index/a1.jpg
// module id = Tb4z
// module chunks = 202